import { render, staticRenderFns } from "./ActionPostback.vue?vue&type=template&id=118fda2f&"
import script from "./ActionPostback.vue?vue&type=script&lang=js&"
export * from "./ActionPostback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports